module.exports = window.crypto;
